/**
 * Buchhaltungsvorbereitung – Platzhalter.
 *
 * Der Menüpunkt und die Freischaltung stehen, der Arbeitsbereich selbst ist
 * noch nicht gebaut. Bewusst eine eigene Seite statt eines toten Links: Ein
 * Klick, der wortlos auf „Meine Aufgaben" zurückwirft, sieht aus wie ein Fehler.
 */

export function Buchhaltungsvorbereitung() {
  return (
    <div className="eh-inhalt">
      <div>
        <div
          style={{
            fontSize: 10.5,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: 'var(--eh-text-blass)',
            fontWeight: 600,
            marginBottom: 6,
          }}
        >
          Buchhaltung
        </div>
        <h1 style={{ fontSize: 30, fontWeight: 600, margin: 0, color: 'var(--eh-text)' }}>
          Buchhaltungsvorbereitung
        </h1>
      </div>

      <div className="eh-karte" style={{ padding: '26px 28px' }}>
        <p className="eh-hinweis" style={{ margin: 0, lineHeight: 1.65 }}>
          Dieser Bereich ist vorbereitet, aber noch nicht gebaut. Der Zugang ist bereits geregelt:
          freigeschaltet sind Eveline und Jana, die Geschäftsführung sieht ihn ohnehin.
        </p>
        <p className="eh-hinweis" style={{ marginBottom: 0, lineHeight: 1.65 }}>
          Was hier entstehen soll, entscheidet ihr – über
          {' '}
          <strong style={{ color: 'var(--eh-text-2)' }}>Verbesserungsvorschläge</strong> lässt sich
          das festhalten, damit es nicht in einem Gespräch verloren geht.
        </p>
      </div>
    </div>
  );
}